import { URL_PREFIX } from '../constants/api';

export interface TrackIgnore {
  isrc: string;
  is_active: boolean;
  created_at: string;
  created_by: {
    email: string;
    id: number;
    name: string;
  };
}

export async function getTrackIgnores(isrc: string): Promise<TrackIgnore[]> {
  try {
    const resp = await fetch(`${URL_PREFIX}/api/v1/track-ignore/${isrc}`);

    if (!resp.ok) {
      throw new Error(`Failed to fetch track ignores: ${resp.statusText}`);
    }

    return (await resp.json()) as TrackIgnore[];
  } catch (error) {
    console.error('getTrackIgnores error:', error);

    throw error;
  }
}

export async function getTrackIgnore(
  isrc: string,
): Promise<TrackIgnore | null> {
  try {
    const resp = await fetch(
      `${URL_PREFIX}/api/v1/track-ignore/active/${isrc}`,
    );

    if (resp.status === 404) {
      return null;
    }

    if (!resp.ok) {
      throw new Error(`Failed to fetch track ignore: ${resp.statusText}`);
    }

    return (await resp.json()) as TrackIgnore;
  } catch (error) {
    console.error('getTrackIgnore error:', error);

    throw error;
  }
}

export async function unignoreTrack(isrc: string): Promise<TrackIgnore> {
  try {
    const resp = await fetch(
      `${URL_PREFIX}/api/v1/track-ignore/close/${isrc}`,
      {
        method: 'PATCH',
      },
    );

    if (!resp.ok) {
      throw new Error(`Failed to unignore track: ${resp.statusText}`);
    }

    return (await resp.json()) as TrackIgnore;
  } catch (error) {
    console.error('unignoreTrack error:', error);

    throw error;
  }
}

export async function ignoreTrack(isrc: string): Promise<TrackIgnore> {
  try {
    const resp = await fetch(`${URL_PREFIX}/api/v1/track-ignore/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ isrc }),
    });

    if (!resp.ok) {
      throw new Error(`Failed to ignore track: ${resp.statusText}`);
    }

    return (await resp.json()) as TrackIgnore;
  } catch (error) {
    console.error('ignoreTrack error:', error);

    throw error;
  }
}

export async function getIgnoresBulk(isrcs: string[]): Promise<TrackIgnore[]> {
  try {
    const resp = await fetch(`${URL_PREFIX}/api/v1/track-ignore/active`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ isrcs }),
    });

    if (!resp.ok) {
      throw new Error(`Failed to fetch bulk track ignores: ${resp.statusText}`);
    }

    return (await resp.json()) as TrackIgnore[];
  } catch (error) {
    console.error('getIgnoresBulk error:', error);

    throw error;
  }
}
